import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const ModalPortal = ({ children, isOpen }) => {
  const [modalRoot, setModalRoot] = useState(null);

  useEffect(() => {
    // Create or get the modal root element
    let root = document.getElementById('modal-root');
    
    if (!root) {
      root = document.createElement('div');
      root.id = 'modal-root';
      root.style.position = 'fixed';
      root.style.top = '0';
      root.style.left = '0';
      root.style.width = '100%';
      root.style.height = '100%';
      root.style.zIndex = '9999'; // Very high z-index
      root.style.pointerEvents = 'auto'; // Allow modal to capture pointer events
      document.body.appendChild(root);
    }

    setModalRoot(root);

    // Cleanup function to remove the modal root if no modals are using it
    return () => {
      // Only remove if this was the last modal and no children remain
      const modalRoot = document.getElementById('modal-root');
      if (modalRoot && modalRoot.children.length === 0) {
        document.body.removeChild(modalRoot);
      }
    };
  }, []);

  // Prevent body scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isOpen]);

  // Only render portal if modal root exists and modal is open
  if (!modalRoot || !isOpen) {
    // Clear the modal root styles when modal is closed
    if (modalRoot) {
      modalRoot.style.pointerEvents = 'none';
    }
    return null;
  }

  // Set the modal root styles when modal is open
  if (modalRoot) {
    modalRoot.style.pointerEvents = 'auto';
  }

  return createPortal(children, modalRoot);
};

export default ModalPortal;
